import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import EffectCategory from '../../../domain/entities/EffectCategory';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexEffectCategoriesSuccess: {
      const result = action.payload as PaginatedResult<EffectCategory>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
